export enum ThemeColor {
    Norm = 'norm',
    Weak = 'weak',
    Danger = 'danger',
    Warning = 'warning',
    Success = 'success',
    Info = 'info',
}

export type ThemeColorUnion = `${ThemeColor}`;
